 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1PARTING from '@/components/0_chapter1parting'
 import A_CHAPTER2DIVINEBLOOD from '@/components/1_chapter2divineblood'
 import A_CHAPTER3BENEFACTOR from '@/components/2_chapter3benefactor'
 import A_CHAPTER4MIXEDPLAY from '@/components/3_chapter4mixedplay'
 import A_CHAPTER5DUMMY from '@/components/4_chapter5dummy'
 import A_CHAPTER6HETEROPROTUBERANCE from '@/components/5_chapter6heteroprotuberance'
 import A_CHAPTER7BEAT from '@/components/6_chapter7beat'
 import A_CHAPTER8BARGAINING from '@/components/7_chapter8bargaining'
 import A_CHAPTER9ZINGYANGTENG from '@/components/8_chapter9zingyangteng'
 import A_CHAPTER10HOMICIDE from '@/components/9_chapter10homicide'
 import A0_CHAPTER11SPIRITBONETEST from '@/components/10_chapter11spiritbonetest'
 import A1_CHAPTER12TESTMEDICINEBOY from '@/components/11_chapter12testmedicineboy'
 import A2_CHAPTER13LETYOUBEAT from '@/components/12_chapter13letyoubeat'
 import A3_CHAPTER14LIFTINGEYEBROWSANDEXHALINGBREATH from '@/components/13_chapter14liftingeyebrowsandexhalingbreath'
 import A4_CHAPTER15INVITATION from '@/components/14_chapter15invitation'
 import A5_CHAPTER16APPRECIATIONCONFERENCEOFTHESPIRITTREASURES from '@/components/15_chapter16appreciationconferenceofthespirittreasures'
 import A6_CHAPTER17INTHECONFERENCEOFAPPRECIATIONOFTHESPIRITTREASURES from '@/components/16_chapter17intheconferenceofappreciationofthespirittreasures'
 import A7_CHAPTER18THESPIRITUALARTIFACTREWARDASSEMBLY from '@/components/17_chapter18thespiritualartifactrewardassembly'
 import A8_CHAPTER19DEMONSLAYINGTOWEROFTHEHOLYSPIRIT from '@/components/18_chapter19demonslayingtoweroftheholyspirit'
 import A9_CHAPTER20MAGICAPPARATUS from '@/components/19_chapter20magicapparatus'
 import A0_CHAPTER21CONFRONTATIONOFSPIRITTREASURES from '@/components/20_chapter21confrontationofspirittreasures'
 import A1_CHAPTER22FIGHTINGWITHSPIRITTREASURES from '@/components/21_chapter22fightingwithspirittreasures'
 import A2_CHAPTER23INVITATIONFROMXIAOYUER from '@/components/22_chapter23invitationfromxiaoyuer'
 import A3_CHAPTER24CONFLICT from '@/components/23_chapter24conflict'
 import A4_CHAPTER25LONGTALKANDPLANNING from '@/components/24_chapter25longtalkandplanning'
 import A5_CHAPTER26JIYANGCITY from '@/components/25_chapter26jiyangcity'
 import A6_CHAPTER27EXPOSURE from '@/components/26_chapter27exposure'
 import A7_CHAPTER28ASSAULTED from '@/components/27_chapter28assaulted'
 import A8_CHAPTER29GIANTSHIP from '@/components/28_chapter29giantship'
 import A9_CHAPTER30FIGHTINGVILLAINS from '@/components/29_chapter30fightingvillains'
 import A0_CHAPTER31STRUGGLE from '@/components/30_chapter31struggle'
 import A1_CHAPTER32MAKEAKILLING from '@/components/31_chapter32makeakilling'
 import A2_CHAPTER33COMPULSION from '@/components/32_chapter33compulsion'
 import A3_CHAPTER34HADES from '@/components/33_chapter34hades'
 import A4_CHAPTER35BRONZEDOOR from '@/components/34_chapter35bronzedoor'
 import A5_CHAPTER36NETHERWATER from '@/components/35_chapter36netherwater'
 import A6_CHAPTER37BOUNDARYSEA from '@/components/36_chapter37boundarysea'
 import A7_CHAPTER38RELIEVING from '@/components/37_chapter38relieving'
 import A8_CHAPTER39SUBTERRANEANMAN from '@/components/38_chapter39subterraneanman'
 import A9_CHAPTER40DANGER from '@/components/39_chapter40danger'
 import A0_CHAPTER41EVILSPIRIT from '@/components/40_chapter41evilspirit'
 import A1_CHAPTER42SHATTEREDDOMAIN from '@/components/41_chapter42shattereddomain'
 import A2_CHAPTER43ASTRALWARSHIPS from '@/components/42_chapter43astralwarships'
 import A3_CHAPTER44CARDIACNUCLEUS from '@/components/43_chapter44cardiacnucleus'
 import A4_CHAPTER45WANXIANGMANOR from '@/components/44_chapter45wanxiangmanor'
 import A5_CHAPTER46WARSHIPASCENDING from '@/components/45_chapter46warshipascending'
 import A6_CHAPTER47CHANNEL from '@/components/46_chapter47channel'
 import A7_CHAPTER48THESECRETONTHESTONE from '@/components/47_chapter48thesecretonthestone'
 import A8_CHAPTER49BUSINESS from '@/components/48_chapter49business'
 import A9_CHAPTER50BIDDING from '@/components/49_chapter50bidding'
 import A0_CHAPTER51DECORATION from '@/components/50_chapter51decoration'
 import A1_CHAPTER52ESCAPE from '@/components/51_chapter52escape'
 import A2_CHAPTER53WHITETASSEL from '@/components/52_chapter53whitetassel'
 import A3_CHAPTER54WINGSONGHU from '@/components/53_chapter54wingsonghu'
 import A4_CHAPTER55SONGHU from '@/components/54_chapter55songhu'
 import A5_CHAPTER56MYSTICALMATERIALSUPPLIER from '@/components/55_chapter56mysticalmaterialsupplier'
 import A6_CHAPTER57FLATMESSAGE from '@/components/56_chapter57flatmessage'
 import A7_CHAPTER58STARTOFMARTIALARTSCOMPETITION from '@/components/57_chapter58startofmartialartscompetition'
 import A8_CHAPTER59WARFOUNDATION from '@/components/58_chapter59warfoundation'
 import A9_CHAPTER60WINNING from '@/components/59_chapter60winning'
 import A0_CHAPTER61MOUNTAINANDRIVERSEAL from '@/components/60_chapter61mountainandriverseal'
 import A1_CHAPTER62OLDURCHIN from '@/components/61_chapter62oldurchin'
 import A2_CHAPTER63BS from '@/components/62_chapter63bs'
 import A3_CHAPTER64GHOSTSHADOW from '@/components/63_chapter64ghostshadow'
 import A4_CHAPTER65BROADCASTBOX from '@/components/64_chapter65broadcastbox'
 import A5_CHAPTER66PRACTICEPLACE from '@/components/65_chapter66practiceplace'
 import A6_CHAPTER67ACQUISITIONOFMEDICINES from '@/components/66_chapter67acquisitionofmedicines'
 import A7_CHAPTER68BITTERCULTIVATION from '@/components/67_chapter68bittercultivation'
 import A8_CHAPTER69AUDITORYCANAL from '@/components/68_chapter69auditorycanal'
 import A9_CHAPTER70BREAKTHROUGHPREPARATION from '@/components/69_chapter70breakthroughpreparation'
 import A0_CHAPTER71FOUNDATION from '@/components/70_chapter71foundation'
 import A1_CHAPTER72EXTREMELYARROGANT from '@/components/71_chapter72extremelyarrogant'
 import A2_CHAPTER73ZHANFENGCHAO from '@/components/72_chapter73zhanfengchao'
 import A3_CHAPTER74INVITATION from '@/components/73_chapter74invitation'
 import A4_CHAPTER75SOLDIERSBOOK from '@/components/74_chapter75soldiersbook'
 import A5_CHAPTER76LAWENFORCEMENTHALL from '@/components/75_chapter76lawenforcementhall'
 import A6_CHAPTER77INVITATIONFROMRENTIANXIANG from '@/components/76_chapter77invitationfromrentianxiang'
 import A7_CHAPTER78BOOKPAVILIONOLDMAN from '@/components/77_chapter78bookpavilionoldman'
 import A8_CHAPTER79BOOKPAVILIONADMINISTRATOR from '@/components/78_chapter79bookpavilionadministrator'
 import A9_CHAPTER80THREAT from '@/components/79_chapter80threat'
 import A0_CHAPTER81WITHAGREATTREASUREINHAND from '@/components/80_chapter81withagreattreasureinhand'
 import A1_CHAPTER82SPIRITUALPAPERANDINK from '@/components/81_chapter82spiritualpaperandink'
 import A2_CHAPTER83SEEMILLIONSMORE from '@/components/82_chapter83seemillionsmore'
 import A3_CHAPTER84EARTHENJAR from '@/components/83_chapter84earthenjar'
 import A4_CHAPTER85SKYPROUDTALISMAN from '@/components/84_chapter85skyproudtalisman'
 import A5_CHAPTER86BACKTOHUANGLONGTOWN from '@/components/85_chapter86backtohuanglongtown'
 import A6_CHAPTER87CRITICALCONDITION from '@/components/86_chapter87criticalcondition'
 import A7_CHAPTER88FALSEDEATH from '@/components/87_chapter88falsedeath'
 import A8_CHAPTER89WAKE from '@/components/88_chapter89wake'
 import A9_CHAPTER90SETUP from '@/components/89_chapter90setup'
 import A0_CHAPTER91NIGHTOFTHEBLIZZARDKILLING from '@/components/90_chapter91nightoftheblizzardkilling'
 import A1_CHAPTER92TALISMANSPIRIT from '@/components/91_chapter92talismanspirit'
 import A2_CHAPTER93INTERROGATION from '@/components/92_chapter93interrogation'
 import A3_CHAPTER94NIUDANIAN from '@/components/93_chapter94niudanian'
 import A4_CHAPTER95GOODSAMARITAN from '@/components/94_chapter95goodsamaritan'
 import A5_CHAPTER96ENCOUNTER from '@/components/95_chapter96encounter'
 import A6_CHAPTER97SOULFORMINGBYSTRENGTH from '@/components/96_chapter97soulformingbystrength'
 import A7_CHAPTER98SURVIVAL from '@/components/97_chapter98survival'
 import A8_CHAPTER99ONTHEEVEOFTHENEWSTUDENTSSURVIVALTRAINING from '@/components/98_chapter99ontheeveofthenewstudentssurvivaltraining'
 import A9_CHAPTER100FLOWERSANDMOONS from '@/components/99_chapter100flowersandmoons'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1parting",
 			"name" : "0_chapter1parting",
 			"component" : A_CHAPTER1PARTING
 		},
 		{
 			"path" : "/1_chapter2divineblood",
 			"name" : "1_chapter2divineblood",
 			"component" : A_CHAPTER2DIVINEBLOOD
 		},
 		{
 			"path" : "/2_chapter3benefactor",
 			"name" : "2_chapter3benefactor",
 			"component" : A_CHAPTER3BENEFACTOR
 		},
 		{
 			"path" : "/3_chapter4mixedplay",
 			"name" : "3_chapter4mixedplay",
 			"component" : A_CHAPTER4MIXEDPLAY
 		},
 		{
 			"path" : "/4_chapter5dummy",
 			"name" : "4_chapter5dummy",
 			"component" : A_CHAPTER5DUMMY
 		},
 		{
 			"path" : "/5_chapter6heteroprotuberance",
 			"name" : "5_chapter6heteroprotuberance",
 			"component" : A_CHAPTER6HETEROPROTUBERANCE
 		},
 		{
 			"path" : "/6_chapter7beat",
 			"name" : "6_chapter7beat",
 			"component" : A_CHAPTER7BEAT
 		},
 		{
 			"path" : "/7_chapter8bargaining",
 			"name" : "7_chapter8bargaining",
 			"component" : A_CHAPTER8BARGAINING
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js